import * as React from "react";
import type { SVGProps } from "react";
const SvgHeatingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M10.473 2.776c-.715 1.073-.39 1.73.02 2.56.432.873.968 1.959-.02 3.44a.496.496 0 0 1-.694.14.5.5 0 0 1-.138-.693c.668-1.003.37-1.607-.043-2.442V5.78c-.443-.893-.993-2.006.043-3.558a.5.5 0 0 1 .832.554M14.456 2.776c-.715 1.073-.39 1.73.021 2.56.432.873.968 1.959-.02 3.44a.5.5 0 1 1-.833-.553c.668-1.002.37-1.606-.043-2.441l-.002-.003c-.44-.893-.99-2.004.045-3.557a.5.5 0 0 1 .832.554M18.46 5.337c-.412-.832-.736-1.488-.02-2.56a.5.5 0 0 0-.833-.555c-1.034 1.553-.485 2.664-.044 3.557v.003c.414.835.712 1.439.044 2.44a.5.5 0 0 0 .832.555c.99-1.482.453-2.568.021-3.44M6.5 12a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 1 0v-9a.5.5 0 0 0-.5-.5M9 12.5a.5.5 0 0 1 1 0v9a.5.5 0 0 1-1 0zM12.5 12a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 1 0v-9a.5.5 0 0 0-.5-.5M15 12.5a.5.5 0 0 1 1 0v9a.5.5 0 0 1-1 0zM18.5 12a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 1 0v-9a.5.5 0 0 0-.5-.5M21 12.5a.5.5 0 0 1 1 0v9a.5.5 0 0 1-1 0z"
    />
    <path
      fill="#858585"
      fillRule="evenodd"
      d="M5.5 10h17c1.38 0 2.5 1.122 2.5 2.5v9c0 1.378-1.12 2.5-2.5 2.5H21v1.5a.5.5 0 0 1-1 0V24H8v1.5a.5.5 0 0 1-1 0V24H5.5A2.503 2.503 0 0 1 3 21.5v-9C3 11.122 4.121 10 5.5 10m15.006 13H5.5c-.827 0-1.5-.673-1.5-1.5v-9c0-.827.673-1.5 1.5-1.5h17c.827 0 1.5.673 1.5 1.5v9c0 .827-.673 1.5-1.5 1.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHeatingIcon;
